import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import { MedicationCoverage } from "@/Patient/Models/Medication/Enums/Medication";
import { MedicationTerm } from "../Enums/MedicationTerm";

class MedicationResponse {
    public Id: string; // Tag the response to return to the right item when resolving medication
    public IsLightDTO: boolean; // Light or Full

    // Light
    public CodeGen: string;
    public CodeGenValue: string;
    public QuebecCoverageClaimDIN: string; // If null its not covered, otherwise, even empty or 0 , are covered
    public Name: string;
    public Strength: string;
    public Form: string;
    public HasMonograph: boolean;
    public CodeException: KeyValuePair<string, string>[];
    public FormException: KeyValuePair<string, string>[]; // Only the Key is available for light search
    public IsException: boolean;
    public LegalStatus: string;

    // Full
    public Din: string;
    public Manufacturer: string;
    public Route: string;
    public Unit: number;
    public Dose: string;
    public UnitPriceString: string;
    public EstimatedPriceString: string;
    public Quantity: string;
    public FrequencyCode: string;
    public Duration: number;
    public IsNeeded: boolean;
    public RenewalInfo: string;
    public Instruction: string;

    public MedicationCoverages: MedicationCoverages;
    public NewBrunswickInsurancePlan: string;

    public Term: MedicationTerm;
}

class MedicationCoverages {
    public QuebecCoverage: MedicationCoverage | null;
    public AlbertaCoverage: MedicationCoverage | null;
    public BritishColumbiaCoverage: MedicationCoverage | null;
    public PrinceEdwardIslandCoverage: MedicationCoverage | null;
    public ManitobaCoverage: MedicationCoverage | null;
    public NewBrunswickCoverage: MedicationCoverage | null;
    public NovaScotiaCoverage: MedicationCoverage | null;
    public OntarioCoverage: MedicationCoverage | null;
    public SaskatchewanCoverage: MedicationCoverage | null;
    public NewfoundlandCoverage: MedicationCoverage | null;
    public FirstPeoplesCoverage: MedicationCoverage | null;

    public static getCoverageByProvinceCode(provCode: string, coverage: MedicationCoverages): MedicationCoverage {
        if (!coverage) {
            return MedicationCoverage.NotCovered;
        }

        switch (provCode) {
            case "AB":
                return coverage.AlbertaCoverage;
            case "BC":
                return coverage.BritishColumbiaCoverage;
            case "MB":
                return coverage.ManitobaCoverage;
            case "NB":
                return coverage.NewBrunswickCoverage;
            case "NL":
                return coverage.NewfoundlandCoverage;
            case "NS":
                return coverage.NovaScotiaCoverage;
            case "ON":
                return coverage.OntarioCoverage;
            case "PE":
                return coverage.PrinceEdwardIslandCoverage;
            case "QC":
                return coverage.QuebecCoverage;
            case "SK":
                return coverage.SaskatchewanCoverage;
            case "YT":
            case "NU":
            case "NT":
                return coverage.FirstPeoplesCoverage;
            default:
                return MedicationCoverage.NotCovered;
        }
    }
}

class GetLimitedUseCodesResponse {
    public LimitedUseCodes: string[];
}

export { GetLimitedUseCodesResponse, MedicationCoverages, MedicationResponse };
